import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/services/firebase/analytics.service";

const ROUTE_TITLES: Record<string, string> = {
  "/": "BurnChart | Startup Runway Calculator",
  "/signup": "Sign Up | BurnChart",
  "/signin": "Sign In | BurnChart",
  "/dashboard": "Dashboard | BurnChart",
  "/settings/billing": "Billing | BurnChart",
  "/help": "Help | BurnChart",
};

function resolvePageTitle(pathname: string): string {
  if (ROUTE_TITLES[pathname]) {
    return ROUTE_TITLES[pathname];
  }

  if (pathname.startsWith("/settings/")) {
    return "Settings | BurnChart";
  }

  if (pathname.startsWith("/help/")) {
    return "Help | BurnChart";
  }

  return "BurnChart";
}

/** Logs GA4 page_view on route changes (Firebase Analytics → linked GA4 property). */
export function AnalyticsPageTracker() {
  const location = useLocation();

  useEffect(() => {
    const pageTitle = resolvePageTitle(location.pathname);
    void trackPageView(location.pathname, pageTitle);
  }, [location.pathname, location.search]);

  return null;
}
